export const Props = () => ({
  //--------------------------------------------------------------------------
  //                            Массив с результатами поиска
  //--------------------------------------------------------------------------
  results: {
    type: Array,
    default: () => []
  }
  //xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx
});